import React from 'react';
import './SpinnerNew.scss';

export default function spinner ({ load }) {
  return (
    <>
      {load && <div className="loading-spinner fixed">
        <div className="loader-circle">Loading...</div>
      </div>}
    </>
  );
};

// export default spinner;
